<div [class]="{ 'vertical-divider': vertical, 'divider': !vertical }" [style.margin]="margin"></div>
